
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configuration3dAlertAttention: {
    id: "Configuration3dAlert.attention",
    defaultMessage: "How to begin?",
  },
  configuration3dAlertMessage: {
    id: "Configuration3dAlert.message",
    defaultMessage: "At first, select your favorite trough via the button. And now you can start with your individual washbasin. Have a lot of fun with our new 3D configurator!",
  },
});

export default MESSAGES;